import React from 'react';
import { LibidoExpressPage } from './pages/LibidoExpressPage';
export function App() {
  return <LibidoExpressPage data-id="element-0" />;
}